import React, { useContext } from 'react'
import { Box, Typography } from '@mui/material'
import { ButtonAction } from '../../../Simple'
import { iconsPayment } from '../../../../assets'
import { AddCredCard } from '../../../Modais'
import { CheckoutContext } from '../../../../contexts/CheckoutContext'

export default function MiniCheckout() {
  const { sttCtxChkt, actionsChkt, modaisChkt, pagamentosDisponiveis } = useContext(CheckoutContext)

  const enablePix = sttCtxChkt.diaria?.metodosPagamento.includes('PIX')
  const enableCard = sttCtxChkt.diaria?.metodosPagamento.includes('Cartão de Crédito')
  const enableLocal = sttCtxChkt.diaria?.metodosPagamento.includes('Pagamento Local')

  return (
    <Box sx={stMob.containMiniCheckout}>
      <Typography variant='h6' className='text-title-section'>
        Qual a forma de pagamento?
      </Typography>
      {enablePix && !sttCtxChkt.selDinheiro && !sttCtxChkt.selCardCredit && (
        <ButtonAction
          Icon={iconsPayment.logoPix}
          titleLabel='PIX'
          text='Pague pelo site'
          pay={'payMetod'}
          disabled={pagamentosDisponiveis.pix === 'limiteDias' || !pagamentosDisponiveis.pix}
          unavailableMessage={
            pagamentosDisponiveis.pix === 'limiteDias'
              ? 'Pix indisponivel para agendamentos com mais de 4 meses de antecedência'
              : !pagamentosDisponiveis.pix
                ? 'Pix indisponivel no momento'
                : ''
          }
          confirmed={sttCtxChkt.selPix}
          onClick={() => {
            actionsChkt.selectModePay('pix')
          }}
        />
      )}
      {enableCard && !sttCtxChkt.selDinheiro && !sttCtxChkt.selPix && (
        <>
          {modaisChkt.cartaoCredito && (
            <AddCredCard
              modal={modaisChkt.cartaoCredito}
              mode={'select-card'}
              text='Pague pelo site'
              disabled={
                pagamentosDisponiveis.cartao === 'limiteDias' || !pagamentosDisponiveis.cartao
              }
              unavailableMessage={
                pagamentosDisponiveis.cartao === 'limiteDias'
                  ? 'Cartão de crédito indisponivel para agendamentos com mais de 28 dias de antecedência'
                  : !pagamentosDisponiveis.cartao
                    ? 'Cartão de crédito indisponivel no momento'
                    : ''
              }
              ClosedModal={() => {
                actionsChkt.handleModaisChkt('cartaoCredito', false)
              }}
            />
          )}
          <ButtonAction
            Icon={iconsPayment.creditCard}
            titleLabel='Cartão de Crédito'
            text='Pague agora'
            pay={'payMetod'}
            confirmed={sttCtxChkt.cardSelected !== null}
            onClick={() => {
              actionsChkt.handleModaisChkt('cartaoCredito', true)
            }}
          />
        </>
      )}
      {enableLocal && !sttCtxChkt.selPix && !sttCtxChkt.selCardCredit && (
        <ButtonAction
          Icon={iconsPayment.payColor}
          titleLabel='Dinheiro'
          text='Pague no local'
          pay={'payMetod'}
          confirmed={sttCtxChkt.selDinheiro}
          onClick={() => {
            actionsChkt.selectModePay('dinheiro')
          }}
        />
      )}
      {(sttCtxChkt.selPix || sttCtxChkt.selCardCredit || sttCtxChkt.selDinheiro) && (
        <Box sx={stMob.containMiniCheckout}>
          <Typography fontWeight='bold' sx={{ width: '100%', textAlign: 'left' }}>
            Resumo dos valores
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Typography variant='body2' color='textSecondary'>
              Subtotal
            </Typography>
            <Typography variant='body2' color='textSecondary'>
              {sttCtxChkt.diaria.valor.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Typography variant='body2' fontWeight='bold'>
              Você irá pagar {sttCtxChkt.selDinheiro === 'local' ? 'no local' : 'agora'}
            </Typography>
            <Typography variant='body2' fontWeight='bold'>
              {sttCtxChkt.diaria.valor.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  )
}

const stMob = {
  containMiniCheckout: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    height: 'auto',
    padding: '10px',
  },
  containDetailsPayment: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 'auto',
    padding: '10px',
  },
}
